import React, { useRef, useState, useCallback, useEffect } from "react";

// Spracheingabe per Web Speech API (läuft im Browser, kein Backend, keine Kosten).
// Ruft onResult(text) mit jedem fertig erkannten Satzstück auf. Deutsch (de-DE),
// benötigt HTTPS + Mikrofon-Erlaubnis. Inline-SVG statt Icon-Lib (keine Abhängigkeit).
const SpeechRecognition =
  typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);

function MicGlyph({ size = 15 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="9" y="2" width="6" height="12" rx="3" />
      <path d="M5 10v1a7 7 0 0 0 14 0v-1" />
      <line x1="12" y1="19" x2="12" y2="22" />
    </svg>
  );
}

export default function DictateButton({ onResult, label = "Diktieren", title = "Spracheingabe" }) {
  const [listening, setListening] = useState(false);
  const recogRef = useRef(null);
  const onResultRef = useRef(onResult);
  onResultRef.current = onResult;
  const supported = !!SpeechRecognition;

  // Beim Unmount eine laufende Aufnahme sauber beenden.
  useEffect(() => () => { try { recogRef.current && recogRef.current.stop(); } catch (e) {} }, []);

  const toggle = useCallback(() => {
    if (!supported) return;
    if (listening) { try { recogRef.current && recogRef.current.stop(); } catch (e) {} return; }

    const recog = new SpeechRecognition();
    recog.lang = "de-DE";
    recog.continuous = true;       // weiterhören, bis bewusst gestoppt wird
    recog.interimResults = true;
    recog.onresult = (event) => {
      let finalChunk = "";
      for (let i = event.resultIndex; i < event.results.length; i++) {
        if (event.results[i].isFinal) finalChunk += event.results[i][0].transcript;
      }
      const text = finalChunk.trim();
      if (text) onResultRef.current && onResultRef.current(text);
    };
    recog.onerror = (e) => {
      setListening(false);
      if (e.error === "not-allowed" || e.error === "service-not-allowed") {
        alert("Mikrofon-Zugriff wurde blockiert. Bitte im Browser erlauben und erneut versuchen.");
      }
    };
    recog.onend = () => setListening(false);
    recogRef.current = recog;
    try { recog.start(); setListening(true); } catch (e) {}
  }, [listening, supported]);

  if (!supported) {
    return (
      <button type="button" className="dictate-btn" disabled
        title="Spracheingabe wird von diesem Browser nicht unterstützt (Chrome empfohlen).">
        <MicGlyph /> Diktieren
      </button>
    );
  }

  return (
    <button type="button" className={"dictate-btn" + (listening ? " is-listening" : "")}
      onClick={toggle} title={listening ? "Aufnahme stoppen" : title}>
      <MicGlyph /> {listening ? "Höre zu … (zum Stoppen klicken)" : label}
    </button>
  );
}
